module.exports = __webpack_public_path__ + "static/media/influence_tracks_expansion.f843a3e9.png";